import React from 'react';
import { Link } from 'react-router-dom';
// import Header from '../components/Header'; // Assuming a shared Header component exists
import GuestHeader from '../components/GuestHeader'; // Use GuestHeader
import Footer from '../components/Footer'; // Assuming a shared Footer component exists

const WaitlistSuccess = () => {
    return (
        <div className="flex flex-col min-h-screen">
            <GuestHeader /> {/* Use GuestHeader */}
            <main className="flex-grow container mx-auto px-4 py-8">
                <div className="max-w-md mx-auto bg-white p-8 rounded-lg shadow-md text-center">
                    <h1 className="text-3xl font-bold mb-6 text-gray-800">Success!</h1>
                    <p className="text-lg text-gray-600 mb-6">
                        You've been successfully added to the waitlist. We'll notify you soon!
                    </p>
                    <Link
                        to="/"
                        className="inline-block bg-indigo-600 text-white px-6 py-2 rounded hover:bg-indigo-700 transition duration-300"
                    >
                        Back to Home
                    </Link>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default WaitlistSuccess;
